import React, { Component } from 'react';
import cn from 'classnames';

import style from './splitter.less';

class HandleBar extends Component {
  render() {
    const { className, handleMouseDown } = this.props;
    return (
      <div
        className={cn(style.handleBar, className)}
        onMouseDown={(e) => handleMouseDown(e)}
        onTouchStart={(e) => handleMouseDown(e)}
      />
    );
  }
}

export default HandleBar;
